import {
    REGISTER_SIDEWINDOW, UNREGISTER_SIDEWINDOW, SET_SIDEBAR_WIDTH, SIDEBAR_MAXIMIZE
} from '../actions/sidebar';

const defaultState = {
    maximized: null,
    width: Math.min(window.innerWidth, 575),
    sidewindows: []
};

export default function details(state = defaultState, action) {
    switch (action.type) {
        case UNREGISTER_SIDEWINDOW: {
            const windowId = action.windowId;
            const sidewindows = (state.sidewindows || []).concat();
            const newSidewindows = [];
            sidewindows.forEach(dw => {
                if (windowId != dw.id) {
                    newSidewindows.push(dw);
                }
            });
            return {...state, sidewindows: newSidewindows};
        }
        case REGISTER_SIDEWINDOW: {
            const windowId = action.windowId;
            const sidewindows = (state.sidewindows || []).concat();
            sidewindows.push({
                id: windowId
            });
            return {...state, sidewindows: sidewindows};
        }
        case SET_SIDEBAR_WIDTH: {
            const width = action.width;
            return {...state, width: width};
        }
        case SIDEBAR_MAXIMIZE: {
            const windowId = action.windowId;
            return {...state, maximized: windowId};
        }
        default:
            return state;
    }
}
